import { colorsPalettes } from "@similarweb/styles";
import { FlexColumn, FlexRowFlexStart } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";
import { contentWrapperBaseStyles } from "../../styles";

export const StyledMainContent = styled(FlexColumn)`
    color: ${colorsPalettes.carbon[300]};
`;

export const StyledActionsRow = styled(FlexRowFlexStart)`
    column-gap: 4px;
`;

export const StyledView = styled(FlexColumn)`
    ${contentWrapperBaseStyles};

    row-gap: 24px;
    padding: 24px 16px 24px 32px;
`;
